module.exports = __webpack_public_path__ + "static/img/12.7800637.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/12.png
// module id = C9M2
// module chunks = 0